import styled, { css } from 'styled-components';
import { transparentize } from 'polished';

interface IRightElementContainerProps {
  checked: boolean;
  hasError: boolean;
}

interface IContainerProps {
  checked: boolean;
  hasError: boolean;
}

export const Container = styled.div<IContainerProps>`
  width: 100%;

  > button {
    width: 100%;

    cursor: pointer;

    min-height: 68px;

    border-radius: ${({ theme }) => theme.borderRadius.sm};
    padding: ${({ theme }) => theme.spacing.sm};
    border: ${({ theme, hasError }) =>
      `1px solid ${hasError ? theme.colors.danger : theme.colors.gray[100]}`};
    background: ${({ theme }) => theme.colors.surface};

    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.sm};

    transition: all ease-in 0.3s;

    &:hover {
      filter: brightness(0.98);
    }

    ${({ checked, theme }) =>
      checked &&
      css`
        border-color: ${theme.colors.primary};
        background-color: ${transparentize(0.96, theme.colors.primary)};

        svg {
          color: ${theme.colors.primary} !important;
        }
      `}
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 17.5px;
    height: 17.5px;
    color: ${({ theme }) => theme.colors.onSurface};
    transition: color ease-in 0.3s;
  }
`;

export const Content = styled.div`
  font-size: 14px;
  line-height: 68px;
  color: ${({ theme }) => theme.colors.onSurface};
  margin-right: auto;
  flex: 1;
  overflow: hidden;
  display: flex;
  align-items: center;

  > div {
    display: flex;
    flex-direction: column;
    gap: 2px;

    max-width: 100%;

    > strong {
      font-size: 12px;
      color: ${({ theme }) => theme.colors.onSurface};
      font-weight: 600;
      line-height: 12px;
      text-align: left;

      margin-right: auto;
    }

    > p {
      color: ${({ theme }) => theme.colors.onSurface};
      font-size: 12px;
      line-height: 14px;
      font-weight: 300;
      text-align: left;
      margin-top: 4px;

      margin-right: auto;
    }
  }
`;

export const RightElementContainer = styled.div<IRightElementContainerProps>`
  min-height: 20px;
  min-width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 16px;
    height: 16px;
    color: ${({ theme, hasError }) =>
      hasError ? theme.colors.danger : theme.colors.gray[200]} !important;
    transition: color ease-in 0.3s;
  }
`;
